@if (label()) {
  <label
    [for]="fieldId"
    class="label-input form-label text-primary text-uppercase text-start"
    [class.cbb-text-field-mask__label--admin]="appearance() === 'admin'">
    {{ label() }}
  </label>
}
<input
  [id]="fieldId"
  [class]="inputClass()"
  [class.cbb-text-field-mask__input--admin]="appearance() === 'admin'"
  [class.is-invalid]="isInvalid()"
  [placeholder]="placeholder()"
  [readOnly]="readonly()"
  autocomplete="off"
  [(ngModel)]="value"
  [mask]="mask()"
  [prefix]="prefix()"
  [shownMaskExpression]="shownMaskExpression()"
  (blur)="onBlur($event)"
  (input)="onInput($event)" />
@if (mensajeError()) {
  <div class="error-message" [class.cbb-text-field-mask__error--admin]="appearance() === 'admin'">{{ mensajeError() }}</div>
}
